export default {
    state: {
        ssProducts: [],
    },
    mutations: {
        ssSetProduct(state, payload) {
            state.ssProducts.push(payload)
        },
        ssSetProductById(state, payload) {
            state.ssProducts[payload.id] = payload.product
        },
        ssClearProducts(state) {
            state.ssProducts = []
        },
    },
    actions: {
        ssSetProduct ({commit}, payload) {
            commit('ssSetProduct', payload)
        },
        ssSetProductById ({commit}, payload) {
            commit('ssSetProductById', payload)
        },
        ssClearProducts ({commit}) {
            commit('ssClearProducts')
        },
    },
    getters: {
        ssIsSetProducts: (state) => state.ssProducts.length,
        ssGetProducts: (state) => state.ssProducts,
    }
}
